import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import '../superadmin/AddDistrict.css';

const EditRegistrationCode = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState({
    code: '',
    description: '',
    is_active: true
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchCode();
  }, [id]);

  const fetchCode = async () => {
    try {
      const response = await axios.get('/api/registration-codes/district');
      const code = response.data.find(c => c.id === id);
      if (code) {
        setFormData({
          code: code.code,
          description: code.description || '',
          is_active: code.is_active
        });
      }
    } catch (error) {
      console.error('Failed to fetch code:', error);
      setError('Failed to load registration code');
    }
  };

  const handleChange = (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setFormData({
      ...formData,
      [e.target.name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await axios.put(`/api/registration-codes/${id}`, formData);
      navigate('/district-admin/registration-codes');
    } catch (error) {
      setError(error.response?.data?.error || 'Failed to update registration code');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-district">
      <h2>Edit Registration Code</h2>
      {error && <div className="error-message">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Code *</label>
          <input
            type="text"
            name="code"
            value={formData.code}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Description</label>
          <input
            type="text"
            name="description"
            value={formData.description}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label>
            <input
              type="checkbox"
              name="is_active"
              checked={formData.is_active}
              onChange={handleChange}
            />
            {' '}Active
          </label>
          <small>Inactive codes cannot be used for registration</small>
        </div>

        <div className="form-actions">
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Updating...' : 'Update Code'}
          </button>
          <button 
            type="button" 
            className="btn-secondary" 
            onClick={() => navigate('/district-admin/registration-codes')}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditRegistrationCode;

